import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import DigitalClockButton from './DigitalClockButton';

export default class DigitalClock extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.currentHour = 12;
    this.currentMinute = 0;
    this.currentDayTime = 'PM';

    this.clockFace = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._digital_clock_face, this);

    this.hourUpButton = new DigitalClockButton(this.scene, -120 - 40,95,UIAssetKeys._button_up, SoundAssetKeys._digital_up, this.hourUpClicked.bind(this));
    this.add(this.hourUpButton);

    this.hourDownButton = new DigitalClockButton(this.scene, -120 - 40,145,UIAssetKeys._button_down, SoundAssetKeys._digital_down, this.hourDownClicked.bind(this));
    this.add(this.hourDownButton);

    this.minuteUpButton = new DigitalClockButton(this.scene, 120 - 120,95,UIAssetKeys._button_up, SoundAssetKeys._digital_up, this.minuteUpClicked.bind(this));
    this.add(this.minuteUpButton);

    this.minuteDownButton = new DigitalClockButton(this.scene, 120 - 120,145,UIAssetKeys._button_down, SoundAssetKeys._digital_down, this.minuteDownClicked.bind(this));
    this.add(this.minuteDownButton);

    this.pmUpButton = ABCyaPhaser.Buttons.addDefaultButton(160,95,UIAssetKeys._button_up, null, SoundAssetKeys._digital_up, this.pmUpClicked.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });

    this.pmDownButton = ABCyaPhaser.Buttons.addDefaultButton(160,145,UIAssetKeys._button_down, null, SoundAssetKeys._digital_down, this.pmDownClicked.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });

    this.colonLabel = ABCyaPhaser.Text.addText(-50 - 40, -155, '120pt', 0xffffff, FontKeys._dimboregular, ':', this, false).setOrigin(0);

    this.hourLabel = ABCyaPhaser.Text.addText(-60 - 40, -145, '120pt', 0xffffff, FontKeys._dimboregular, this.currentHour, this, false).setOrigin(1, 0);

    this.minuteLabel = ABCyaPhaser.Text.addText(15 - 70, -145,'120pt', 0xffffff, FontKeys._dimboregular, `0${this.currentMinute}`, this, false).setOrigin(0);

    this.pmLabel = ABCyaPhaser.Text.addText(165, -115, 120, 0xffffff, FontKeys._dimboregular, this.currentDayTime, this, true).setOrigin(0.5, 0);
    this.updateTimeLabel();

    ABCyaPhaser.Text.resizeFontToFitWidth(this.pmLabel, 130);
  }

  hourUpClicked () {
    this.currentHour++;

    if (this.currentHour > 12) {
      this.currentHour = 1;
    }

    if (this.currentHour > 11) {
      if (this.currentDayTime === 'AM') {
        this.currentDayTime = 'PM';
      }
      else {
        this.currentDayTime = 'AM';
      }

      this.updateTimeLabel();
    }

    this.makeHour();

    this.emit('CHANGED');
  }

  hourDownClicked () {
    this.currentHour--;

    if (this.currentHour < 1) {
      this.currentHour = 12;
    }

    if (this.currentHour === 11) {
      if (this.currentDayTime === 'AM') {
        this.currentDayTime = 'PM';
      }
      else {
        this.currentDayTime = 'AM';
      }

      this.updateTimeLabel();
    }

    this.makeHour();

    this.emit('CHANGED');
  }

  makeHour () {
    let hourString = `${this.currentHour}`;

    if (this.currentHour < 10) {
      hourString = `0${this.currentHour}`;
    }

    this.hourLabel.text = hourString;
  }

  minuteUpClicked () {
    this.currentMinute++;

    if (this.currentMinute > 59) {
      this.currentMinute = 0;
    }

    this.makeMinute();

    this.emit('CHANGED');
  }

  minuteDownClicked () {
    this.currentMinute--;

    if (this.currentMinute < 0) {
      this.currentMinute = 59;
    }

    this.makeMinute();

    this.emit('CHANGED');
  }

  makeMinute () {
    let minString = `${this.currentMinute}`;

    if (this.currentMinute < 10) {
      minString = `0${this.currentMinute}`;
    }

    this.minuteLabel.text = minString;
  }

  pmUpClicked () {
    if (this.currentDayTime === 'AM') {
      this.currentDayTime = 'PM';
    }
    else {
      this.currentDayTime = 'AM';
    }

    this.updateTimeLabel();

    this.emit('CHANGED');
  }

  pmDownClicked () {
    if (this.currentDayTime === 'AM') {
      this.currentDayTime = 'PM';
    }
    else {
      this.currentDayTime = 'AM';
    }

    this.updateTimeLabel();

    this.emit('CHANGED');
  }

  getHoursAndMinutes () {
    return [this.currentHour, this.currentMinute, this.currentDayTime];
  }

  setHoursAndMinutes (hour, minutes, timeOfDay) {
    this.currentDayTime = timeOfDay;
    this.currentHour = hour;
    this.currentMinute = minutes;

    this.makeHour();
    this.makeMinute();

    this.updateTimeLabel();
  }

  updateTimeLabel() {
    this.pmLabel.text = ABCyaPhaser.Localization.instance.getLocalizedString(`time_labels.${this.currentDayTime === 'AM' ? 'ante_meridiem' : 'post_meridiem'}`);
  }
}